/* Keep the inherited Symmetry cart drawer's accessibility state in sync.
   Its visible class already controls the actual open/closed state. */
(() => {
  const syncDrawer = () => {
    document.querySelectorAll('.cart-drawer-modal').forEach(drawer => {
      if (drawer.dataset.mhmHsaAriaBound) return;
      drawer.dataset.mhmHsaAriaBound = 'true';
      const sync = () => drawer.setAttribute('aria-hidden',
        drawer.classList.contains('cc-popup--visible') ? 'false' : 'true');
      sync();
      new MutationObserver(sync).observe(drawer, {attributes: true, attributeFilter: ['class']});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncDrawer, {once: true});
  else syncDrawer();
  document.addEventListener('shopify:section:load', syncDrawer);
})();
